/**
 * QA Hub API Setup
 * Uses shared @quotech/api bootstrap — see packages/api/src/setupHubApi.ts
 */
export { getConfiguredClient } from '@quotech/api'
import { setupHubApi } from '@quotech/api'

/** Call once in main.tsx before rendering. */
export function initializeApi() {
  setupHubApi({ hubName: 'QA' })
}
